export const SURFACE = "surface";
export const SUCCESS = "success";
export const WARNING = "warning";
export const INFO = "info";
export const PRIMARY = "primary";
export const ERROR = "error";

export type Color =
  | typeof SURFACE
  | typeof SUCCESS
  | typeof WARNING
  | typeof INFO
  | typeof PRIMARY
  | typeof ERROR;
